const measures = {
  reset: 0,
  content: {
    width: 400,
    height: 750,
  },
  authScreen: {
    logoLogin: {
      width: 242,
      height: 47,
    },
    inputLogin: {
      width: 340,
      height: 50,
    },
  },
  bottomNav: {
    widthItem: 58,
    height: 55,
  },
};

export default measures;
